/* --- SkeletonLine ----------------------------------------------------------- */

interface SkeletonLineProps {
  width?: string;
  height?: string;
}

export function SkeletonLine({ width = '100%', height = '16px' }: SkeletonLineProps) {
  return <div className="skeleton-shimmer" style={{ width, height }} />;
}

/* --- SkeletonCard ----------------------------------------------------------- */

export function SkeletonCard() {
  return (
    <div
      className="skeleton-shimmer w-full min-w-[280px] rounded-md"
      style={{ height: 180 }}
    />
  );
}

/* --- SkeletonGrid ----------------------------------------------------------- */

interface SkeletonGridProps {
  count?: number;
}

export function SkeletonGrid({ count = 6 }: SkeletonGridProps) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

/* --- SkeletonTabs ----------------------------------------------------------- */

export function SkeletonTabs() {
  return (
    <div className="flex gap-2 mb-4">
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className="skeleton-shimmer rounded-pill"
          style={{ width: 80, height: 32 }}
        />
      ))}
    </div>
  );
}
